// extracted by css-extract-rspack-plugin
export default {"root":"root-2SJX8","arrowRoot":"arrowRoot-1Bs8Y","body":"body-1nRuu","closeButton":"closeButton-1HfjN"};